module.exports = __webpack_public_path__ + "static/img/card-04.8a535c7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-04.jpeg
// module id = 3vR3
// module chunks = 14